module.exports = __webpack_public_path__ + "static/img/ic_guanliyuan.1600800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_guanliyuan.png
// module id = vBx4
// module chunks = 0